import { Route } from "react-router";
import { credentialsPathPatterns } from "./credentials-path-patterns";
import CreateCredentialSheetPage from "../pages/create/create-credential.sheet.page";
import EditCredentialSheetPage from "../pages/edit/edit-credential.sheet.page";
import CredentialInfoDialogPage from "../pages/info/credential-info.dialog.page";
import CredentialListPage from "../pages/list/credential-list.page";

export const credentialsRoutes = [
  <Route key="credentials-list" path={credentialsPathPatterns.list} element={<CredentialListPage />}>
    <Route path={credentialsPathPatterns.create} element={<CreateCredentialSheetPage />} />
    <Route path={credentialsPathPatterns.edit} element={<EditCredentialSheetPage />} />
    <Route path={credentialsPathPatterns.info} element={<CredentialInfoDialogPage />} />
  </Route>,
];
